const DATE_LOCALE = 'en-GB';

const STATUS_LABELS = {
  NEW: 'New',
  ASSIGNED: 'Assigned',
  SMS_SENT: 'Invite sent',
  AWAITING_CONTRACTOR_RESPONSE: 'Awaiting contractor response',
  WORKER_ACCEPTED: 'Accepted by contractor',
  AWAITING_QUOTE: 'Awaiting quote',
  WORKER_DECLINED: 'Declined by contractor',
  NEEDS_REASSIGNMENT: 'Needs reassignment',
  QUOTE_SUBMITTED: 'Quote submitted',
  QUOTE_ACCEPTED: 'Quote approved',
  QUOTE_DECLINED: 'Quote rejected',
  QUOTE_REVISION_REQUESTED: 'Quote changes requested',
  SCHEDULING: 'Scheduling',
  DATE_PROPOSED: 'Visit proposed',
  AWAITING_LANDLORD_CONFIRMATION: 'Awaiting landlord confirmation',
  AWAITING_TENANT_CONFIRMATION: 'Awaiting tenant confirmation',
  APPOINTMENT_REJECTED: 'Appointment rejected',
  SCHEDULED: 'Scheduled',
  REMINDER_SENT: 'Reminder sent',
  ON_MY_WAY: 'On the way',
  ARRIVED: 'Arrived',
  WORK_STARTED: 'Work started',
  WORK_FINISHED: 'Work finished',
  PROOF_SUBMITTED: 'Completion sent',
  COMPLETION_SUBMITTED: 'Completion submitted',
  FOLLOW_UP_REQUIRED: 'Follow-up required',
  REOPENED: 'Reopened',
  LANDLORD_APPROVED: 'Approved',
  COMPLETED: 'Completed',
  CLOSED: 'Closed',
  CANCELLED: 'Cancelled',
  NOT_STARTED: 'Not started',
  NOT_SUBMITTED: 'Not submitted',
  PENDING_APPROVAL: 'Waiting for approval',
  REVISION_REQUESTED: 'Changes requested',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
  CONFIRMED: 'Confirmed',
  PROPOSED: 'Proposed',
  AWAITING_LANDLORD_REVIEW: 'Waiting for landlord review',
  NOT_REQUIRED: 'Not required',
  TENANT: 'Tenant',
  LANDLORD: 'Landlord',
  KEYS_HELD: 'Keys held',
  TENANT_REQUIRED: 'Tenant access required',
  LANDLORD_REQUIRED: 'Landlord access required',
  NO_INTERNAL_ACCESS: 'No internal access',
  AWAITING_RESPONSE: 'Awaiting response',
  REQUESTED_RESCHEDULE: 'Requested another time',
  RESCHEDULE_REQUESTED: 'Reschedule requested',
};

function parseDate(value) {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatDate(value, fallback = 'Not set') {
  const date = parseDate(value);
  if (!date) return fallback;
  return new Intl.DateTimeFormat(DATE_LOCALE, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(date);
}

export function formatDateTime(value, fallback = 'Not scheduled') {
  const date = parseDate(value);
  if (!date) return fallback;
  return new Intl.DateTimeFormat(DATE_LOCALE, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).format(date).replace(',', ' at');
}

export function formatStatus(value, fallback = 'Not started') {
  const normalized = String(value || '').trim().toUpperCase();
  if (!normalized) return fallback;
  if (STATUS_LABELS[normalized]) return STATUS_LABELS[normalized];

  const label = normalized
    .split('_')
    .filter(Boolean)
    .map((part) => part.charAt(0) + part.slice(1).toLowerCase())
    .join(' ');
  return label || fallback;
}

export function formatMoneyGBP(value, fallback = 'TBA') {
  if (value === undefined || value === null || value === '') return fallback;
  const amount = Number(value);
  if (!Number.isFinite(amount)) return fallback;
  return new Intl.NumberFormat(DATE_LOCALE, {
    style: 'currency',
    currency: 'GBP',
    maximumFractionDigits: amount % 1 === 0 ? 0 : 2,
  }).format(amount);
}

export function maskPhone(value) {
  const phone = String(value || '').trim();
  if (!phone) return 'No phone number';
  const visible = phone.slice(-4);
  return `Ends ${visible}`;
}
